import { render, staticRenderFns } from "./PwaPopUp.vue?vue&type=template&id=5737d9a6&scoped=true&"
import script from "./PwaPopUp.vue?vue&type=script&lang=ts&"
export * from "./PwaPopUp.vue?vue&type=script&lang=ts&"
import style0 from "./PwaPopUp.vue?vue&type=style&index=0&id=5737d9a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5737d9a6",
  null
  
)

export default component.exports